import { render } from "./ReceiptButton.vue?vue&type=template&id=118f5f40&scoped=true"
import script from "./ReceiptButton.vue?vue&type=script&lang=js"
export * from "./ReceiptButton.vue?vue&type=script&lang=js"

import "./ReceiptButton.vue?vue&type=style&index=0&id=118f5f40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118f5f40"]])

export default __exports__